import React from "react";
import './Vendor.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Vendor = ({ vendors = [], setupReadyVendor = [], brand, style, season }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // console.log("vendor, setup ready vendor", vendors, setupReadyVendor)
    const onSampleTrackerHandle = (vendorName, isSetupVendor) => {
        localStorage.setItem(
            "srData",
            JSON.stringify({
                searchFilter: style,
                brandFilter: brand,
                colorFilter: "",
                sizeFilter: "",
                vendorFilter: vendorName || "",
                sale_sampleFilter: 0,
                seasonFilter: [],
            })
        );
        localStorage.setItem(
            "srMassData",
            JSON.stringify({
                searchFilter: style || "",
                brandFilter: brand,
                colorFilter: "",
                sizeFilter: "",
                vendorFilter: vendorName || "",
                sale_samplefilter: 0,
                seasonFilter: [],
            })
        );
        localStorage.setItem(
            "srtData",
            JSON.stringify({
                brand: brand,
                style: style,
                factory: vendorName,
                rejected_date: "",
                sale_sample: 0,
                season: season,
            })
        );
        if (isSetupVendor) {
            if (["DICKI", "DICKC", "DICKW", "DICKG", "DCKGW"].includes(brand)) {
                localStorage.setItem("srActiveKey", "1");
                navigate("/m3-setup-sheet/dickies-socks", "_blank");
            } else if (brand === "SAUC") {
                localStorage.setItem("srActiveKey", "2");
                navigate("/m3-setup-sheet/saucony", "_blank");
            } else if (brand === "EDBR") {
                localStorage.setItem("srActiveKey", "3");
                navigate("/m3-setup-sheet/eddie-bauer", "_blank");
            } else if (brand === "PD") {
                localStorage.setItem("srActiveKey", "4");
                navigate("/m3-setup-sheet/pd", "_blank");
            } else if (["MFSM", "MFSW"].includes(brand)) {
                localStorage.setItem("srActiveKey", "7");
                navigate("/m3-setup-sheet/my-favorite-socks", "_blank");
            } else if (["NOST"].includes(brand)) {
                localStorage.setItem("srActiveKey", "10");
                navigate("/m3-setup-sheet/north-state", "_blank");
            } else if (["INFR"].includes(brand)) {
                localStorage.setItem("srActiveKey", "11");
                navigate("/m3-setup-sheet/inferno", "_blank");
            } else if (["TRUE"].includes(brand)) {
                localStorage.setItem("srActiveKey", "12");
                navigate("/m3-setup-sheet/true-energy", "_blank");
            } else if (["NSTA"].includes(brand)) {
                localStorage.setItem("srActiveKey", "13");
                navigate("/m3-setup-sheet/north-state-apparel", "_blank");
            } else if (["RDRY"].includes(brand)) {
                localStorage.setItem("srtActiveKey", "14");
                navigate("/m3-setup-sheet/run-dry", "_blank");
            }
            else {
                localStorage.setItem("srActiveKey", "1");
                navigate("/m3-setup-sheet/dickies-socks", "_blank");
            }
            return;
        }

        if (["DICKI", "DICKC", "DICKW", "DICKG", "DCKGW"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "1");
            window.open("/sample-receipt-tracker/dickies-socks", "_blank");
        } else if (brand === "SAUC") {
            localStorage.setItem("srtActiveKey", "2");
            window.open("/sample-receipt-tracker/saucony", "_blank");
        } else if (brand === "EDBR") {
            localStorage.setItem("srtActiveKey", "3");
            window.open("/sample-receipt-tracker/eddie-bauer", "_blank");
        } else if (brand === "PD") {
            localStorage.setItem("srtActiveKey", "4");
            window.open("/sample-receipt-tracker/pd", "_blank");
        } else if (brand === "HAGR") {
            localStorage.setItem("srtActiveKey", "5");
            window.open("/sample-receipt-tracker/haggar", "_blank");
        } else if (["DCKGU", "DCKIU"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "8");
            window.open("/sample-receipt-tracker/dickies-underwear", "_blank");
        } else if (["MFSM", "MFSW"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "9");
            window.open("/sample-receipt-tracker/my-favorite-socks", "_blank");
        } else if (["NOST"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "10");
            window.open("/sample-receipt-tracker/north-state", "_blank");
        } else if (["INFR"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "11");
            window.open("/sample-receipt-tracker/inferno", "_blank");
        } else if (["TRUE"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "12");
            window.open("/sample-receipt-tracker/true-energy", "_blank");
        } else if (["NSTA"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "13");
            window.open("/sample-receipt-tracker/north-state-apparel", "_blank");
        } else if (["RDRY"].includes(brand)) {
            localStorage.setItem("srtActiveKey", "14");
            window.open("/sample-receipt-tracker/run-dry", "_blank");
        }
        else {
            localStorage.setItem("srtActiveKey", "1");
            window.open("/sample-receipt-tracker/dickies-socks", "_blank");
        }
    };

    const renderVendorList = (list = [], isSetupVendor = false) => {
        // console.log("rebdorvendor", list);
        return list.map((v, index) => (

            <div key={index} className="line-items-container">
                <p>
                    <span
                        className={(v?.vendor_status == "Product Ready" || v?.vendor_status == "TP Verified") ? "setup-ready-vendor-name" : v?.vendor_status == "In Development" ? "development-vendor-name" : "vendor-name"}
                        onClick={(e) => {
                            e.stopPropagation();
                            onSampleTrackerHandle(v.vendor, isSetupVendor);
                        }}
                        style={{ cursor: "pointer" }}
                    >

                        {v.vendor}
                    </span>
                    <span> : {v.line_items} line items</span>
                    <span> : {v.colors} Colors, {v.sizes} Sizes</span>
                </p>
            </div>
        ));
    };

    return (
        <div className="status-vendor-wrapper">
            {setupReadyVendor?.length > 0 && (
                <>
                    <p style={{ color: "#0c3d5e", fontWeight: "600" }}>SETUP VENDORS</p>
                    <div className="status-vendor-details">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {renderVendorList(setupReadyVendor, true)}
                        </div>
                    </div>
                </>
            )}
            {vendors?.length > 0 && (
                <>
                    <p style={{ color: "#0c3d5e", fontWeight: "600" }}>VENDORS</p>
                    <div className="status-vendor-details">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {renderVendorList(vendors, false)}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Vendor;